'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dProxies$002dPage$0024 from "./presto.-List-Proxies-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002483 from "./presto.-Presto-Router$$anon$83.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$82() {
  this.bo6 = null;
  this.bnY = null;
  this.bnZ = false;
  this.bo7 = null;
  this.bo8 = false;
  this.bob = null;
  this.bo4 = null;
  this.bo5 = false;
  this.bo0 = null;
  this.bo1 = false;
  this.bo2 = null;
  this.bo3 = false;
  this.bo9 = false;
  this.boa = false;
  this.bo6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bob = "ListProxiesPage";
}
export { $c_Lpresto_PrestoRouter$$anon$82 as $c_Lpresto_PrestoRouter$$anon$82 };
$p = $c_Lpresto_PrestoRouter$$anon$82.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$82;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$82() {
}
export { $h_Lpresto_PrestoRouter$$anon$82 as $h_Lpresto_PrestoRouter$$anon$82 };
$h_Lpresto_PrestoRouter$$anon$82.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bo6;
});
$p.L = (function() {
  if ((!this.bnZ)) {
    this.bnY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bnZ = true;
  }
  return this.bnY;
});
$p.O = (function() {
  if ((!this.bo8)) {
    this.bo7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bo8 = true;
  }
  return this.bo7;
});
$p.E = (function() {
  return this.bob;
});
$p.t = (function() {
  if ((!this.bo5)) {
    this.bo4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bo5 = true;
  }
  return this.bo4;
});
$p.M = (function() {
  if ((!this.bo1)) {
    this.bo0 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bo1 = true;
  }
  return this.bo0;
});
$p.Q = (function() {
  if ((!this.bo3)) {
    this.bo2 = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002483.$c_Lpresto_PrestoRouter$$anon$83();
    this.bo3 = true;
  }
  return this.bo2;
});
$p.w = (function() {
  if ((!this.boa)) {
    this.bo9 = false;
    this.boa = true;
  }
  return this.bo9;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee542) => ((p) => \u03b4scrutinee542))($j_presto$002e$002dList$002dProxies$002dPage$0024.$m_Lpresto_ListProxiesPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$82 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$82, "presto.PrestoRouter$$anon$82", ({
  OR: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$82 as $d_Lpresto_PrestoRouter$$anon$82 };
//# sourceMappingURL=presto.-Presto-Router$$anon$82.js.map
